/**
 * Een bevestiging in tekst, op de plek waar de handeling begon. Geen modaal
 * venster: het paneel staat onder de knop die het opriep, zegt in één zin wat er
 * gaat gebeuren en wat dat betekent, en heeft precies twee knoppen. De rode knop
 * is de enige rode knop die de app kent; hij staat alleen hier.
 */
import { Melding } from './Melding';

type BevestigingProps = {
  /** De vraag, met het aantal erin: "28 woningen verwijderen uit De Pijp?" */
  vraag: string;
  /** Wat het betekent, in één of twee zinnen. */
  uitleg?: string;
  /** Het woord op de rode knop. */
  knop: string;
  bezig?: boolean;
  fout?: unknown;
  onBevestig: () => void;
  onAnnuleer: () => void;
};

export function Bevestiging({
  vraag,
  uitleg,
  knop,
  bezig = false,
  fout,
  onBevestig,
  onAnnuleer,
}: BevestigingProps) {
  return (
    <div className="paneel flex flex-col gap-2 border-brick/40 px-3 py-2.5">
      <p className="text-[12.5px] text-ink">{vraag}</p>
      {uitleg ? <p className="text-[11.5px] text-muted">{uitleg}</p> : null}
      {fout ? <Melding fout={fout} /> : null}
      <div className="flex items-center gap-2">
        <button type="button" className="knop-gevaar" onClick={onBevestig} disabled={bezig}>
          {bezig ? 'Bezig' : knop}
        </button>
        <button type="button" className="knop-stil" onClick={onAnnuleer} disabled={bezig}>
          Annuleren
        </button>
      </div>
    </div>
  );
}
